import type { CsnSearchVenue } from '@/models/CsnSearchVenue';

const searchResultLimitPerPage = 25;
const diamondPlusAdsLimitPerPage = 2;

export type SearchResultsRank = {
  venues: Record<string, number>;
  fourDiamondAds: Record<string, number>;
  diamondPlusAds: Record<string, number>;
};

/* Assigns a rank to each venue in the search results and associates the rank 
   with the corresponding venue ID. The rankings can be provided for 4D Ads, Diamond Plus Ads,
   and regular venue results.
*/
export function getSearchResultRankForVenues(venues: Array<CsnSearchVenue>, pageNumber: number): SearchResultsRank {
  const searchResultRankForVenues: Record<string, number> = {};
  const searchResultRankForFourDiamondAds: Record<string, number> = {};
  const searchResultRankForDiamondPlusAds: Record<string, number> = {};
  let venueRank = 0;
  let diamondPlusAdRank = 0;
  let fourDiamondAdRank = 0;

  venues.forEach(venue => {
    if (venue.featuredLevel === 'FOUR_DIAMOND') {
      ++fourDiamondAdRank;
      searchResultRankForFourDiamondAds[venue.id] = fourDiamondAdRank + diamondPlusAdsLimitPerPage * (pageNumber - 1);
    } else if (venue.featuredLevel === 'DIAMOND_PLUS') {
      searchResultRankForDiamondPlusAds[venue.id] = ++diamondPlusAdRank;
    } else {
      ++venueRank;
      searchResultRankForVenues[venue.id] = venueRank + searchResultLimitPerPage * (pageNumber - 1);
    }
  });
  return {
    venues: searchResultRankForVenues,
    fourDiamondAds: searchResultRankForFourDiamondAds,
    diamondPlusAds: searchResultRankForDiamondPlusAds
  };
}
